<template>
  <DropdownField
    inputId="transact-vendor-number"
    name="keystore.vendor_number"
    :label="translate(`${LOCALE_PREFIX}.form.transactVendorNumber`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.transactVendorNumberPlaceholder`)"
    :options="[118, 3600]"
    :disabled="!editMealPlan"
    :required="editMealPlan"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
</script>
